import axios from "axios";

class APIProblemTracking {
  async getChannels() {
    const config = {
      method: "get",
      url: `/api/ProblemTracking/DropdownChannels`,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async getStatuses() {
    const config = {
      method: "get",
      url: `/api/ProblemTracking/DropdownStatuses`,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async getStatusesWithProblems(problemId: number) {
    const config = {
      method: "get",
      url: `/api/ProblemTracking/DropdownStatuses?problemId=${problemId}`,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async getCustomers(params: {
    customerSearchText: string;
    limit?: number;
    offset?: number;
  }) {
    const config = {
      method: "get",
      url: `/api/ProblemTracking/DropdownCustomers`,
      params,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async getDropdownCustomersForReport(params: {
    customerSearchText: string;
    limit?: number;
    offset?: number;
  }) {
    const config = {
      method: "get",
      url: `/api/ProblemTracking/DropdownCustomersForReport`,
      params,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async getCustomersWithProblems(params: {
    subShopTypeId: number;
    customerSearchText: string;
    statusId: number;
    limit: number;
    offset: number;
  }) {
    const config = {
      method: "get",
      url: `/api/ProblemTracking/Reports`,
      params: params,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async getProblemsByCustomer(params: {
    customerId: number;
    reportDate: string;
    groupId: number;
    problemTypeId: number;
    statusId: number;
    limit: number;
    offset: number;
  }) {
    const config = {
      method: "get",
      url: `/api/ProblemTracking/Customers`,
      params,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async getProblemDetail(problemId: number) {
    const config = {
      method: "get",
      url: `/api/ProblemTracking`,
      params: {
        problemId: problemId,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async getProblemGroups() {
    const config = {
      method: "get",
      url: `/api/ProblemTracking/DropdownProblemGroups`,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async getProblemTypes() {
    const config = {
      method: "get",
      url: `/api/ProblemTracking/DropdownProblemTypes`,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async createProblem(payload: any) {
    const config = {
      method: "post",
      url: `/api/ProblemTracking`,
      data: payload,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async resolveProblem(problemId: number, payload: any) {
    const config = {
      method: "post",
      url: `/api/ProblemTracking/${problemId}/Resolution`,
      data: payload,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async approveProblem(problemId: number, payload: { isApprove: boolean }) {
    const config = {
      method: "post",
      url: `/api/ProblemTracking/${problemId}/Approval`,
      data: payload,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }
}

export default APIProblemTracking;
